export default __webpack_public_path__ + "static/media/room [no animated plants].4e7111d9.png";